import TableService from 'src/shared/api/table/TableService';
import { setError, setSuccess, setWarning } from 'src/shared/lib/utils';

export const recalculateCurrentFormRules = async (formId: number) => {
  try {
    const { data } = await TableService.recalculateTableRules(formId);

    const processedTables = data?.processedTables || 0;
    const processedRows = data?.processedRows || 0;
    const failedRows = data?.failedRows || 0;

    setSuccess(
      `Пересчёт правил формы завершён: таблиц=${processedTables}, строк=${processedRows}, ошибок=${failedRows}`,
    );

    if (data?.warnings?.length) {
      const uniqueWarnings = Array.from(new Set(data.warnings.filter(Boolean)));
      const preview = uniqueWarnings.slice(0, 3).join('; ');
      const extraCount = uniqueWarnings.length - Math.min(uniqueWarnings.length, 3);
      const suffix = extraCount > 0 ? ` (+${extraCount})` : '';
      setWarning(`Предупреждения пересчёта правил формы: ${preview}${suffix}`);
    }

    return true;
  } catch (error: any) {
    setError(error?.response?.data?.error || 'Не удалось запустить пересчёт правил текущей формы');
    return false;
  }
};
